// @file UTM capture entrypoint. Logic lives in bits/utm_capture so it can
// be unit-tested outside the vite-plugin-ruby entrypoint glob.
import { applyUtmParamsFromUrl } from '@@/bits/utm_capture'

applyUtmParamsFromUrl()
